import $ from 'jquery';
import bodymovin from 'lottie-web';
var animation = '';
window.addEventListener('px-loaderend',function(){
    //console.log('loaded, anim-ready')
    //console.log('StartAnim');
    /*var animation = bodymovin.loadAnimation({
        container: document.getElementById('loadinganim'), // Required
        path: template_dir+'/assets_src/components/loader/data.json', // Required
        renderer: 'svg', // Required
        loop: false, // Optional
        autoplay: true, // Optional
        name: "Hello World", // Name for future reference. Optional.
    })*/
    //console.log('b4play')
    //console.log(animation)
    if(jQuery('body').hasClass('js-is-home')){
        bodymovin.play('introanim');
    };
});
window.addEventListener('px-ready',function(){
    if(!jQuery('#loadinganim svg').length){
        animation = bodymovin.loadAnimation({
            container: document.getElementById('loadinganim'), // Required
            path: template_dir+'/assets_src/components/loader/data.json', // Required
            renderer: 'svg', // Required
            loop: false, // Optional
            autoplay: false, // Optional
            name: "introanim", // Name for future reference. Optional.
        })
        animation.addEventListener('complete', function(){
            //window.location.href = 'https://www.dribbble.com/chrsalctra'; 
            //console.log('x');
            $('body').removeClass('is-animating');
            $(window).trigger('resize');
            $('.navbar > div,.hero__content').addClass('px-animation-parent');
            var video = $('.hero__container video')[0];
            if(video){
                video.pause();
                video.currentTime = 0;
                video.play();
            }
            window.setTimeout(function(){
                console.log('restart video')
                animation.goToAndStop(0,true);
            },300)
        })
    }
});
$('document').ready(function(){
    //console.log('docready');
    jQuery('.px-loader .bar').css('width','0%');
    if(jQuery('body').hasClass('js-is-home')){
        console.log('startanim')
        window.setTimeout(function(){
            bodymovin.play('introanim');
        },300)
    }
})
window.addEventListener('px-navigationstart',function(){
    //bodymovin.stop('introanim');
    jQuery('.px-loader .bar').css('width','100%');
    jQuery('.px-loader .bar').css('opacity',1);
})